// QL-365 — deleted users stay referenced by history and ownership; their name is
// shown with a marker so nobody mistakes them for an active colleague.
export const T = {
  en_GB: { deleted: "(deleted)" },
  nb_NO: { deleted: "(slettet)" },
} as const;
